import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../../components/button';
import CustomInput from '../../components/customInput/CustomInput';

const OTPModal = ({
  show,
  onClose,
  onVerifySuccess,
  showQrImage = false,
  qrImageUri = '',
  otpLoading,
  otpError
}) => {
  const [otp, setOtp] = useState('');
  const [localOtpError, setLocalOtpError] = useState('');

  useEffect(() => {
    if (!show) {
      setOtp('');
      setLocalOtpError('');
    }
  }, [show]);

  const handleOTPChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    setOtp(value);
    setLocalOtpError('');
  };

  const handleOTPVerify = async () => {
    if (otp.length !== 6) {
      setLocalOtpError('Please enter a valid 6-digit code');
      return;
    }

    const error = await onVerifySuccess(otp);
    if (error) {
      setLocalOtpError(error || 'OTP is invalid or expired');
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: 'none' }} />
      <Modal.Body>
        <div className="otp-modal-content">
          <p style={{ textAlign: 'center', marginBottom: '20px' }}>
            {showQrImage
              ? 'Scan this QR code with your authenticator app'
              : 'Enter an MFA code to complete sign-in'
            }
          </p>

          {showQrImage && qrImageUri && (
            <div style={{ textAlign: 'center' }}>
              <img
                src={qrImageUri}
                alt="MFA QR Code"
                style={{ maxWidth: '200px', maxHeight: '200px' }}
              />
            </div>
          )}

          <div>
            <CustomInput
              type="text"
              value={otp}
              onChange={handleOTPChange}
              maxLength={6}
              placeholder="000000"
              error={localOtpError || otpError}
              style={{
                width: '100%',
                textAlign: 'center',
                fontSize: '1.2rem',
                letterSpacing: '0.5rem',
                padding: '10px'
              }}
            />
          </div>

          <div className="otp-actions">
            <Button
              style={{
                backgroundColor: '#ED1A3D',
                color: 'white',
                width: '100%',
                height: '40px',
                borderRadius: '10px',
                border: 'none',
                cursor: 'pointer',
                marginTop: '20px'
              }}
              onClick={handleOTPVerify}
              disabled={otpLoading}
            >
              {otpLoading ? 'Verifying...' : 'Verify'}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OTPModal;